module.exports = __webpack_public_path__ + "static/img/tutorial1_1.1149b98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coin_dealer/tutorial1_1.png
// module id = C5GG
// module chunks = 0